var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  ref: "pageFrom",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.pageFrom,
                    "label-position": "right",
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.pageFrom.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "orderNo", $$v)
                            },
                            expression: "pageFrom.orderNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.search },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "第三方订单：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.pageFrom.outTradeNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "outTradeNo", $$v)
                            },
                            expression: "pageFrom.outTradeNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.search },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.search },
                          model: {
                            value: _vm.pageFrom.storeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "storeId", $$v)
                            },
                            expression: "pageFrom.storeId",
                          },
                        },
                        _vm._l(_vm.storeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.search },
                          model: {
                            value: _vm.pageFrom.orderStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "orderStatus", $$v)
                            },
                            expression: "pageFrom.orderStatus",
                          },
                        },
                        _vm._l(_vm.orderStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: { change: _vm.search },
                          model: {
                            value: _vm.pageFrom.orderCategory,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "orderCategory", $$v)
                            },
                            expression: "pageFrom.orderCategory",
                          },
                        },
                        _vm._l(_vm.orderCategoryOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-actions" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.isDownloading,
                        disabled: _vm.isDownloading,
                      },
                      on: { click: _vm.exportOrders },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isDownloading ? "导出中..." : "订单导出") +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置搜索")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isDownloading
                ? _c(
                    "div",
                    { staticClass: "download-progress" },
                    [
                      _c("el-progress", {
                        attrs: {
                          percentage: _vm.downloadProgress,
                          status: _vm.downloadProgress === 100 ? "success" : "",
                          "show-text": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "download-status" }, [
                        _vm._v(_vm._s(_vm.downloadStatus)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "订单编号", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "order-no" }, [
                          _c("div", [_vm._v(_vm._s(scope.row.orderNo))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "order-sub-no" }, [
                            _vm._v(_vm._s(scope.row.subOrderNo)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "outTradeNo",
                  label: "第三方订单",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "店铺",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单类型", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.orderCategoryName || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(scope.row.status),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.statusName) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "骑手状态", width: "100", prop: "riderStatus" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "配送方式",
                  "min-width": "250",
                  prop: "reservationType",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "送达时间",
                  "min-width": "250",
                  prop: "reservationTime",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "pickupCode", label: "取货码", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "客户备注",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "quantity", label: "产品数量", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单金额", width: "100", prop: "totalAmount" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payTime", label: "下单时间", width: "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ticketTime", label: "接单时间", width: "150" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "240", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.viewOrder(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _vm._v(" "),
                        _vm.showDeliverButton(scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:merchant:takeout:order:ship",
                                    ],
                                    expression:
                                      "['admin:merchant:takeout:order:ship']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDeliver(scope.row)
                                  },
                                },
                              },
                              [_vm._v("发货")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 3 ||
                        scope.row.status == 4 ||
                        scope.row.status == 5
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.printTicket(scope.row)
                                  },
                                },
                              },
                              [_vm._v("小票打印")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm._acceptOrder(scope.row)
                                  },
                                },
                              },
                              [_vm._v("接单")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCanRefund(scope.row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openRefund(scope.row)
                                  },
                                },
                              },
                              [_vm._v("退款")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 50, 100, 200],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderDetail", { ref: "orderDetailRef" }),
      _vm._v(" "),
      _c("RefundDialog", {
        ref: "refundDialogRef",
        on: { success: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }